export enum AppRoutes {
  LOGIN = 'LOGIN',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  HOME = 'HOME',
  ENTRIES = 'ENTRIES',
  INVITATIONS = 'INVITATIONS',
  CREATE_INVITATION = 'CREATE_INVITATION',
  INVITATION_DETAILS = 'INVITATION_DETAILS',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  EDIT_PERSONAL_INFO = 'EDIT_PERSONAL_INFO',
  UNAUTHORIZED = 'UNAUTHORIZED'
}

export const ROUTE_PATHS: Record<AppRoutes, string> = {
  [AppRoutes.LOGIN]: 'login',
  [AppRoutes.TERMS_AND_CONDITIONS]: 'terms',
  [AppRoutes.HOME]: 'home',
  [AppRoutes.ENTRIES]: 'entries',
  [AppRoutes.INVITATIONS]: 'invitations',
  [AppRoutes.CREATE_INVITATION]: 'create-invitation',
  [AppRoutes.INVITATION_DETAILS]: 'invitation-details',
  [AppRoutes.CHANGE_PASSWORD]: 'change-password',
  [AppRoutes.PERSONAL_INFORMATION]: 'personal-information',
  [AppRoutes.EDIT_PERSONAL_INFO]: 'edit-personal-info',
  [AppRoutes.UNAUTHORIZED]: 'unauthorized'
};

// ===== MAPPING DE RUTAS PARA TÍTULOS =====
export const ROUTE_TITLES: Record<AppRoutes, string> = {
  [AppRoutes.LOGIN]: 'common.titles.login',
  [AppRoutes.TERMS_AND_CONDITIONS]: 'terms.title',
  [AppRoutes.HOME]: 'common.titles.requests',
  [AppRoutes.ENTRIES]: 'invitation.titles.entries',
  [AppRoutes.INVITATIONS]: 'invitation.titles.invitations',
  [AppRoutes.CREATE_INVITATION]: 'common.titles.newRequest',
  [AppRoutes.CHANGE_PASSWORD]: 'common.titles.changePassword',
  [AppRoutes.PERSONAL_INFORMATION]: 'common.titles.personalInformation',
  [AppRoutes.EDIT_PERSONAL_INFO]: 'common.titles.editPersonalInfo',
  [AppRoutes.INVITATION_DETAILS]: 'common.titles.requestDetails',
  [AppRoutes.UNAUTHORIZED]: 'common.titles.unauthorized'
} as const;

